import * as React from "react";
import PropTypes from "prop-types";
const SvgNavigationCalendarNormalXsmall = React.forwardRef(
  ({ color = "currentColor", size = 16, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M6 1H4.75v1H2.625C1.728 2 1 2.728 1 3.625v6.865c0 .478.21.932.576 1.241l3.416 2.885c.293.248.665.384 1.049.384h7.334c.897 0 1.625-.728 1.625-1.625v-9.75C15 2.728 14.272 2 13.375 2H11.25V1H10v1H6zm4 2.25V4h1.25v-.75h2.125c.207 0 .375.168.375.375V4.75H2.25V3.625c0-.207.168-.375.375-.375H4.75V4H6v-.75zM2.25 10V6h11.5v7.375a.375.375 0 01-.375.375H7V10zm.694 1.25H5.75v2.37z"
        fill=""
      />
    </svg>
  )
);
SvgNavigationCalendarNormalXsmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgNavigationCalendarNormalXsmall;
